import { styled } from '@styledComponents';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';
import { themeSpace } from '@utils/styledTheme.util';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const HoneymoonFundWrapper = styled(Box)`
  position: relative;
  background: linear-gradient(180deg, #fef3ea 0%, rgba(255, 249, 245, 0) 100%);
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 512px;
  }
  .text-pairing-body {
    max-width: 460px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      width: 314px;
      max-width: 314px;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 480px;
    }
    .text-pairing-body {
      max-width: 480px;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 390px;
    }
  }
  ${themeMediaQuery('lg')} {
    .text-pairing-title {
      max-width: 470px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 512px;
    }
  }
`;

export const StyledSlider = styled.div`
  width: calc(380px * 12);
  ${themeMediaQuery('below_sm')} {
    width: calc(190px * 12);
  }
`;

export const StyledSlideTrack = styled.div`
  margin-top: ${themeSpace(10)};
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  padding: 0px;
  justify-content: left;
  animation: scroll 35s linear infinite;
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-380px * 6));
    }
  }
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(7)};
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-170px * 6));
      }
    }
  }
`;

export const StyledSlide = styled.div`
  display: table-cell;
  width: 380px;
  ${themeMediaQuery('below_sm')} {
    width: 190px;
  }
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 380px;
  ${themeMediaQuery('below_sm')} {
    width: 190px;
  }
`;

export const StyledGetStartedButton = styled(GetStartedButton)`
  background: transparent;
`;
